module.exports = __webpack_public_path__ + "img/quienes_qualyticare.5f29d4d2.png";